module.exports = "/virtual-football/img/video/clubs/germany/leverkusen.png";


//////////////////
// WEBPACK FOOTER
// ./src/games/virtual-football/img/video/clubs/germany/leverkusen.png
// module id = 297
// module chunks = 6